import { React, ReactDOM } from '../../dependencies';

import MessageList from '../../containers/MessageList';

const Messages = () => {
    return ReactDOM.createPortal(<MessageList />, document.getElementById('messages'));
};

export default Messages;
